var exports = {
    /**
     * @description 读取cookie
     * @public
     * @param {String} n 名称
     * @returns {String} cookie值
     */
    get: function(n) {
        var m = document.cookie.match(new RegExp("(^| )" + n + "=([^;]*)(;|$)"));
        return !m ? "" : decodeURIComponent(m[2]);
    },
    /**
     * @description 设置cookie
     * @public
     *
     * @param {String} name cookie名称
     * @param {String} value cookie值
     * @param {String} [domain = ""] 所在域名
     * @param {String} [path = "/"] 所在路径
     * @param {Number} [hour = 30] 存活时间，单位:小时
     * @example
     *      set('value1','cookieval',"ke.qq.com","/test",24); //设置cookie
     */
    set: function(name, value, domain, path, hour) {
        var expire = new Date();
        expire.setTime(expire.getTime() + (hour ? 3600000 * hour : 30 * 24 * 60 * 60 * 1000));

        document.cookie = name + "=" + value + "; " + "expires=" + expire.toGMTString() + "; path=" + (path ? path : "/") + "; " + (domain ? ("domain=" + domain + ";") : "");
    },

    setSession: function(name, value, domain, path) {
        document.cookie = name + "=" + value + "; path=" + (path ? path : "/") + "; " + (domain ? ("domain=" + domain + ";") : "");
    },

    /**
     * @description 删除指定cookie,复写为过期 !!注意path要严格匹配， /id 不同于/id/
     * @public
     *
     * @param {String} name cookie名称
     * @param {String} [domain] 所在域
     * @param {String} [path = "/"] 所在路径
     * @example
     *      $.cookie.del('id_test'); //删除cookie
     */
    del: function(name, domain, path) {
        document.cookie = name + "=; expires=Mon, 26 Jul 1997 05:00:00 GMT; path=" + (path ? path : "/") + "; " + (domain ? ("domain=" + domain + ";") : "");
    },
    /**
     * @description 删除所有cookie -- 这里暂时不包括目录下的cookie
     * @public
     *
     * @example
     *      $.cookie.clear(); //删除所有cookie
     */

    clear: function() {
        var rs = document.cookie.match(new RegExp("([^ ;][^;]*)(?=(=[^;]*)(;|$))", "gi"));
        // 删除所有cookie
        for (var i in rs) {
            document.cookie = rs[i] + "=;expires=Mon, 26 Jul 1997 05:00:00 GMT; path=/; ";
        }
    },
    /**
     * 获取uin，针对业务,对外开源请删除
     * QQ登录取p_uin或uin然后转码,微信登陆取uid_uin
     * QQ登录情况下，后面3个cookie字段是广点通上报时取uin备选的，
     * 用于解决有些情况下报名上报中uin为空
     * @return {String} uin值
     * @example
     *      $.cookie.uin();
     */
    uin: function() {
        var u;
        if (['2', '1001', '1002'].indexOf(this.get('uid_type')) !== -1) { // 微信用户
            return this.get('uid_uin') || null;
        } else { // QQ用户
            u = this.get('p_luin') || this.get('p_uin') || this.get('uin') ||
                this.get('pt2gguin') || this.get('adid');

            u = !u ? null : parseInt(u.replace(/[^\d]/g, ''), 10); // 需要转码得到uin

            u = u || parseInt(this.get('uin_cookie'), 10) || null; // uin_cookie不需要转码

            return u;
        }
    },
    /**
     * 获取uin，针对业务,对外开源请删除
     * QQ登录取p_uin或uin然后转码,微信登陆取uid_uin
     * Q多余的uin就不要取了，我们只需要真正登录的用户uin
     * @return {String} uin值
     * @example
     *      $.cookie.realUin();
     */
    realUin: function() {
        var u;
        if (['2', '1001', '1002'].indexOf(this.get('uid_type')) !== -1) { // 微信用户
          return this.get('uid_uin') || null;
        } else { // QQ用户
            u = this.get('p_luin') || this.get('p_uin') || this.get('uin') || this.get('uid_uin');

            u = !u ? null : parseInt(u.replace(/[^\d]/g, ''), 10); // 需要转码得到uin

            u = u || parseInt(this.get('uin_cookie'), 10) || null; // uin_cookie不需要转码

            return u;
        }
    }
};


module.exports = exports;
